__turbopack_context__.v({
  "drilldownList": "dLyhZq_drilldownList",
  "rootMenu": "dLyhZq_rootMenu",
  "standaloneMenu": "dLyhZq_standaloneMenu",
  "submenu": "dLyhZq_submenu",
});
